import { FormControl } from '@angular/forms';
import {
  BaseNewRequestControlName,
  InvestorDetailsNewRequestFormGroup,
} from '../../../../shared/base-new-request-form/base-new-request-form.model';

export enum LBRDUUERNewDataUpdateRequestAdditionalControlName {
  ChangeScope = 'changeScope',
  DeterminationOfLocation = 'determinationOfLocation',
}

export const LBRDUUERNewDataUpdateRequestControlName = {
  ...BaseNewRequestControlName,
  ...LBRDUUERNewDataUpdateRequestAdditionalControlName,
};

export interface LBRDUUERNewDataUpdateRequestFormGroup
  extends InvestorDetailsNewRequestFormGroup {
  [LBRDUUERNewDataUpdateRequestControlName.ChangeScope]: FormControl<string>;
  [LBRDUUERNewDataUpdateRequestControlName.DeterminationOfLocation]: FormControl<string>;
}
